// extracted by mini-css-extract-plugin
export var authIntro = "_3-8";
export var authSubtitle = "_3-a";
export var authTitle = "_3-9";
export var backArrowIcon = "_3-g";
export var container = "_3-0";
export var formArea = "_3-7";
export var formContainer = "_3-b";
export var formWrapper = "_3-6";
export var fullWidthButton = "_3-d";
export var inlineErrorNotice = "_3-h";
export var inlineInfoNotice = "_3-i";
export var leftPanel = "_3-1";
export var loadingContainer = "_3-j";
export var loadingSpinner = "_3-k";
export var loadingText = "_3-m";
export var logo = "_3-4";
export var logoContainer = "_3-2";
export var logoLockup = "_3-3";
export var logoSubmark = "_3-5";
export var primaryActionButton = "_3-e";
export var secondaryLinkButton = "_3-f";
export var spin = "_3-l";
export var stackedActions = "_3-c";